import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Button } from "antd";
import { logout } from "../actions/consultesServidor";
import configuracio from "../configuracioEntorns";
import { esborrarValors } from "../actions";

const urlBase = configuracio.ruta;

class Logout extends Component {
  state = {
    redirect: false
  };

  handleLogout = () => {
    const { esborrarValors } = this.props;
    esborrarValors();
    logout();
    this.setState(prevState => ({ ...prevState, redirect: true }));
  };

  render() {
    const { redirect } = this.state;

    if (redirect) {
      return <Redirect to={`${urlBase}/login`} />;
    }

    return (
      <Button icon="logout" onClick={this.handleLogout}>
        Sortir
      </Button>
    );
  }
}
Logout.propTypes = {
  esborrarValors: PropTypes.func.isRequired
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, { esborrarValors })(Logout);
